import { LoaderCircle } from 'lucide-react';

export const FullPageSpinner = () => (
  <div className="bg-background text-primary fixed inset-0 z-50 flex items-center justify-center" role="status">
    <LoaderCircle role="presentation" aria-label="Loading..." className="size-8 animate-spin" />
  </div>
);
